export default __webpack_public_path__ + "static/media/annavaram.0f239b41.png";